import { render, staticRenderFns } from "./BasicFeedback.vue?vue&type=template&id=0c928e3f&"
import script from "./BasicFeedback.vue?vue&type=script&lang=js&"
export * from "./BasicFeedback.vue?vue&type=script&lang=js&"
import style0 from "./BasicFeedback.vue?vue&type=style&index=0&id=0c928e3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports